export function getRiskUnit(field) {
  let riskUnit;
  if (field && field.vehicle) {
    riskUnit = { ...field.vehicle };
  } else if (field && field.property) {
    riskUnit = { ...field.property };
  }
  return riskUnit;
}

export function selectPolicy(riskUnit, lossDate) {
  let policies = JSON.parse(window.sessionStorage.getItem('policyDetails'));

  if (policies) {
    if (riskUnit && riskUnit.policySystemId === 'injuryOnly') {
      policies = policies.filter(
        (policy) => policy.lob === 'PersonalAuto' && policy.policyProvince === 'Ontario' && policy.coverages.hasBasicAccidentBenefits,
      );

      if (!policies.length > 0) {
        return false;
      }

      const filteredPolicies = policies.filter((policy) => policy.coverages.hasEndorsementOPCF47);
      policies = filteredPolicies.length > 0 ? filteredPolicies : policies;

      return getEarliestPolicy(policies, lossDate);
    }

    if (riskUnit && riskUnit.year && riskUnit.policySystemId !== 'injuryOnly') {
      riskUnit.year = parseInt(riskUnit.year, 10);
      const thePolicy = policies.find((policy) => {
        if (policy.vehicles && policy.vehicles.find((policyVehicle) => policyVehicle.policySystemId === riskUnit.policySystemId)) {
          return policy;
        }
        return false;
      });
      return thePolicy;
    }

    if (riskUnit && riskUnit.policySystemId === 'somewhereElse') {
      policies = policies.filter((policy) => policy.lob === 'Homeowners');
      const noLandlordPolicies = policies.filter((policy) => !policy?.properties?.[0]?.type.startsWith('Rented Dwelling'));
      if (noLandlordPolicies.length) {
        return getEarliestPolicy(noLandlordPolicies, lossDate);
      }
      return getEarliestPolicy(policies, lossDate);
    }

    if (riskUnit && riskUnit.address) {
      const thePolicy = policies.find((policy) => {
        if (policy.properties && policy.properties.find((policyProperty) => policyProperty.policySystemId === riskUnit.policySystemId)) {
          return policy;
        }
        return false;
      });

      return thePolicy;
    }
  }
}

export function getPropertyType(propertyType) {
  const types = {
    HOMEOWNERS: 'homeowners',
    CONDO: 'condo',
    LANDLORD: 'landlord',
    TENANT: 'tenant',
  };

  switch (propertyType) {
    case 'Homeowners':
    case 'Homeowners basic':
    case 'Homeowners Enhanced':
    case 'Homeowners Comprehensive':
      return types.HOMEOWNERS;
    case 'Rented Dwelling':
    case 'Rented Dwelling Basic':
    case 'Rented Dwelling Enhanced':
    case 'Rented Dwelling Comprehensive':
      return types.LANDLORD;
    case 'Condo':
    case 'Condo Enhanced':
      return types.CONDO;
    case 'Tenant':
    case 'Tenant Enhanced':
      return types.TENANT;
    default:
      return null;
  }
}

function getEarliestPolicy(array, lossDate) {
  if (lossDate) {
    array.sort((a, b) => {
      const distanceA = Math.abs(new Date(lossDate.value).getTime() - new Date(a.effectiveDate).getTime());
      const distanceB = Math.abs(new Date(lossDate.value).getTime() - new Date(b.effectiveDate).getTime());
      return distanceA - distanceB;
    });
  }
  return array[0];
}
